// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__+PFpM","logo":"panel_logo__r9wfg","navigation":"panel_navigation__Et9Kj","control":"panel_control__rQZZ9"};